import { css, html, LitElement } from 'lit';
import common from '../../styles/common.js';
import '../common/swd-hero.js';
import '../common/table-of-contents.js';

export default class SubPageView extends LitElement {
  static styles = [
    common,
    css`
      :host {
        display: flex;
        flex-direction: column;
      }
    `
  ];

  hideToc = true;

  render() {
    return html`
      <swd-hero
        srcset="public/assets/images/hero-overlayed.png 1600w"
        sizes="1600w"
        src="public/assets/images/hero.png"
      >
        ${this.renderHeroContent()}
      </swd-hero>
      <main>
        ${!this.hideToc ? html`<table-of-contents></table-of-contents>` : ''}
        <div class="container-md">
          ${this.renderContent()}
        </div>
      </main>
    `;
  }

  /** @returns {import('lit').TemplateResult} */
  renderHeroContent() {
    return html``;
  }

  /** @returns {import('lit').TemplateResult} */
  renderContent() {
    throw new Error('Not implemented.');
  }
}